import { TaxonomiesConfig } from 'types'

export const WP_POST_TYPE_NAME = 'pf_product'
export const PRODUCT_URI_FRONT = '' //'product'
export const IMPORT_URI = 'import'
export const PAGE_SIZE = 9
export const CMS_GRAPHQL_ENDPOINT = process.env.REACT_APP_CMS_GRAPHQL_ENDPOINT
export const GENERIC_IMG_NAME = 'generic.jpg'

/**
 * Whether the App is running inside the Wordpress Site, or as a standalone app
*/
export const STANDALONE =
  process.env.REACT_APP_STANDALONE || true ? true : false

/**
 * Running in admin mode presents the Import screen instead of the
 * product finder front-end.
*/
export const ADMIN_MODE = process.env.REACT_APP_ADMIN ? true : false


export const taxonomiesConfig: TaxonomiesConfig = [
  {
    taxonomyId: 'PRODUCTCATEGORY',
    label: 'Product Category',
  },
  {
    taxonomyId: 'COUNTRY',
    label: 'Countries',
    exclusive: true,
    allowNull: false,
  },
  {
    taxonomyId: 'PRODUCINGCOUNTRY',
    label: 'Producer Country',
  },
  { taxonomyId: 'STOCKIST', label: 'Stockist' },
  { taxonomyId: 'BRAND', label: 'Brand Name'},
  { taxonomyId: 'COMMODITY', label: 'Commodity' },
  { taxonomyId: 'DISTRIBUTOR', label: 'Distributor' },
  { taxonomyId: 'LICENSEE', label: 'Licensee' },
  { taxonomyId: 'SUBBRAND', label: 'Sub-brand' },
  { taxonomyId: 'TRACEABLE', label: 'Traceable' },
  {
    taxonomyId: 'ORGANIC',
    label: 'Organic',
    boolean: true,
    booleanLabel: 'Show Organic Products Only',
  },
]
